import React from "react";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import FormApellidos from "./FormApellidos";
import axios from  "axios";
import {API_URL} from "../../../utils/Common";

function ApellidosFlor(props) {
    const [apellidos, setApellidos] = React.useState([]);

    // -- Hook de efecto
    React.useEffect(() => {
        getApellidos();
    }, [])

    function getApellidos () {
        // -- traer apellidos
        axios.get(API_URL+'/catalogos/getApellidos')
            .then(r => {
                setApellidos(r.data.apellidos);
            })
    }

    return (
        <div className="w-full p-3">
            <div className="bg-white border rounded shadow">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <HeadRegresar titulo="Variedades de las Flores" history={props.history} />
                </div>
                <div className="p-5 rounded-b">
                    {/* ---- CONTENIDO --- */}
                    <div className="flex mb-4">
                        <div className="w-1/2 p-2 h-auto">
                            <h2>Alta de la Variedad</h2>
                            <hr className="mb-5"/>
                            <FormApellidos fnGetApellidos={getApellidos} />
                        </div>
                        <div className="w-1/2 p-2 h-auto">
                            <h2>Registros de Variedades</h2>
                            <hr className="mb-5"/>
                            <table className="table-fixed mt-5 w-full">
                                <thead>
                                <tr className="border border-orange-200 text-sm text-white content-center bg-orange-800">
                                    <th className="w-1/6">No</th>
                                    <th>Variedad</th>
                                    <th className="w-1/6">Acciones</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    apellidos.map((apellido, index) => {
                                        return (
                                            <tr className="text-sm" key={index}>
                                                <td className="border px-4 py-2 text-center">{index + 1}</td>
                                                <td className="border px-4 py-2">{apellido.nombre}</td>
                                                <td className="text-center border px-4 py-2">
                                                    <button className="text-xs bg-orange-800 hover:bg-orange-700 text-white py-1 px-1 rounded shadow">
                                                        Remover
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ApellidosFlor;
